import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http';
import type { ProjectSettings } from '@models/projects';

@Service()
export class ProjectSettingsService {
  private readonly http = inject(HttpService);

  async getProjectSettingsAsync(projectId: string): Promise<ProjectSettings> {
    return this.http.getObjectAsync<ProjectSettings>(`mobile/projects/${projectId}/settings`);
  }
}
